$(document).ready(function () {
    var json_len = abcsetup.userOrg.org_attribute.length;
    var alcohol_perc_sel = false;
    if (json_len > 0) {
        $(abcsetup.userOrg.org_attribute).each(function() {
            if (this.taa_compliant_exempt && this.taa_compliant_exempt == 'Y') {
                $("#trade_agreement").attr('required', false).removeClass("invalid");
                $("#trade_agreement").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }

            if (this.country_origin_exempt && this.country_origin_exempt == 'Y') {
                $("select[name='country_origin[]']").attr('required', false).removeClass("invalid");
                $("select[name='country_origin[]']").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }

    var init_class;
    if (abcsetup.item != undefined) {
        init_class = abcsetup.item.role.class;
    }
    else {
        init_class = '';
    }

    /*
    Required logic for identifiers
    */
    $(".article_identifiers").change(function() {
        var this_css_class;
        var css_classes = ["article_identifiers"];
        for (var idx in css_classes) {
            if ($(this).hasClass(css_classes[idx])) {
                this_css_class = css_classes[idx];
                break;
            }
        }
        //console_log(this_css_class+":"+$(this).attr("name")+":"+$(this).val());
        var at_least_one = false;
        $("."+this_css_class).each(function() {
            if ($(this).val()) {
                at_least_one = true;
                return;
            }
        });
        $("."+this_css_class).each(function() {
            if (!at_least_one) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else if ($(this).val()) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else {
                $(this).attr('required', false).removeClass("invalid");
                $(this).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }).trigger("change");

    $(".pack_info").change(function() {
        if ($(this).val() != '') {
        $(".pack_info").attr('required', true);
        $(".pack_info").closest("div.form-group").addClass("required");
        }
        else {
        if ($("#pack_weight").val() == '' && $("#pack_depth").val() == '' && $("#pack_height").val() == '' && $("#pack_width").val() == '' && $("#pack_pieces").val() == '') {
            $(".pack_info").attr('required', false).removeClass("invalid");
            $(".pack_info").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
        }
    }).trigger("change");

    $(".pallet_info").change(function() {
        if ($(this).val() != '') {
            $(".pallet_info").attr('required', true);
            $(".pallet_info").closest("div.form-group").addClass("required");
        }
        else {
        if ($("#pallet_weight").val() == '' && $("#pallet_depth").val() == '' && $("#pallet_height").val() == '' && $("#pallet_width").val() == '' && $("#pallet_pieces").val() == '') {
            $(".pallet_info").attr('required', false).removeClass("invalid");
            $(".pallet_info").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
        }
    }).trigger("change");

    if ($("#item_pieces").val() == "") {
        $("#item_pieces").val("1");
    }
    $("#item_pieces").change(function() {
        var item_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'item') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[item][qty]']").val(item_pieces);
                    if (item_pieces != '') {
                    $("input[name='gtin_items[item][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                    $("input[name='gtin_items[item][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var pack_pieces = $("#pack_pieces").val();
        var pieces_check = Math.round((pack_pieces/item_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#item_pieces").attr('required', false).removeClass("invalid");
            $("#item_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[item][qty]']").val() == $("#item_pieces").val()) {
        $("#item_pieces").trigger("change");
    }

    $("#pack_pieces").change(function() {
        var pack_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
        var enabled = $(this).is(':checked');
            if ($(this).val() == 'inner') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[inner][qty]']").val(pack_pieces);
                    if (pack_pieces != '') {
                        $("input[name='gtin_items[inner][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[inner][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var item_pieces = $("#item_pieces").val();
        var case_pieces = $("#case_pieces").val();
        var pieces_check = Math.round((pack_pieces/item_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#pack_pieces").attr('required', false).removeClass("invalid");
            $("#pack_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }

        pieces_check = Math.round((case_pieces/pack_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#pack_pieces").attr('required', false).removeClass("invalid");
            $("#pack_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[inner][qty]']").val() == $("#pack_pieces").val()) {
        $("#pack_pieces").trigger("change");
    }

    $("#case_pieces").change(function() {
        var case_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'case') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[case][qty]']").val(case_pieces);
                    if (case_pieces != '') {
                        $("input[name='gtin_items[case][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[case][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var pack_pieces = $("#pack_pieces").val();
        var pallet_pieces = $("#pallet_pieces").val();
        var pieces_check = Math.round((case_pieces/pack_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#case_pieces").attr('required', false).removeClass("invalid");
            $("#case_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }

        pieces_check = Math.round((pallet_pieces/case_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#case_pieces").attr('required', false).removeClass("invalid");
            $("#case_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[case][qty]']").val() == $("#case_pieces").val()) {
        $("#case_pieces").trigger("change");
    }

    $("#pallet_pieces").change(function() {
        var pallet_pieces = $(this).val();
        $('.enable_gtin_level').each(function () {
            var enabled = $(this).is(':checked');
            if ($(this).val() == 'pallet') {
                if (!enabled) {
                    return;
                }
                else {
                    $("input[name='gtin_items[pallet][qty]']").val(pallet_pieces);
                    if (pallet_pieces != '') {
                        $("input[name='gtin_items[pallet][qty]']").attr("readonly",true).addClass("readonly");
                    }
                    else {
                        $("input[name='gtin_items[pallet][qty]']").attr("readonly",false).removeClass("readonly");
                    }
                }
            }
        });

        var case_pieces = $("#case_pieces").val();
        var pieces_check = Math.round((pallet_pieces/case_pieces) * 100.0) / 100.0;

        if (pieces_check % 1 == 0) {
            $("#pallet_pieces").attr('required', false).removeClass("invalid");
            $("#pallet_pieces").closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
    });

    if ($("input[name='gtin_items[pallet][qty]']").val() == $("#pallet_pieces").val()) {
        $("#pallet_pieces").trigger("change");
    }

    $("#item_setup_reason").change(function() {
        var item_setup_reason = $(this).val();
        if (item_setup_reason == "Short Dated") {
            $("#short_dated_prod").val("Y").trigger("change");
            //$("#short_dated_offer_letter").addClass("required").show();
        }
        else {
            //$("#short_dated_offer_letter").removeClass("required").hide();
        }
    }).trigger("change");

    $(".moq").change(function() {
        var this_css_class;
        var css_classes = ["moq"];
        for (var idx in css_classes) {
            if ($(this).hasClass(css_classes[idx])) {
                this_css_class = css_classes[idx];
                break;
            }
        }
        //console_log(this_css_class+":"+$(this).attr("name")+":"+$(this).val());
        var at_least_one = false;
        $("."+this_css_class).each(function() {
            if ($(this).val()) {
                at_least_one = true;
                return;
            }
        });
        $("."+this_css_class).each(function() {
            if (!at_least_one) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else if ($(this).val()) {
                $(this).attr('required', true);
                $(this).closest("div.form-group").addClass("required");
            }
            else {
                $(this).attr('required', false).removeClass("invalid");
                $(this).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
            }
        });
    }).trigger("change");

    $.each(['selling_unit','individual_unit','unit_dose'],function() {
        var uom = this;

        /*if (user_role == 'field_team') {
        $("input[name='rx_item["+uom+"_ndc]']").closest("tr").show();
        $("input[name='rx_item["+uom+"_ndc]']").siblings(".input_required_indicator").remove();
        $("input[name='rx_item["+uom+"_ndc]']").closest("td").removeClass("readonly");
        $("input[name='rx_item["+uom+"_ndc]']").after('<span class="input_required_indicator">*</span>');
        }*/

        $("#"+uom+"_ndc10_format").change(function() {
            var ndc10_format = $(this).val();
            var ndc10 = $("#"+uom+"_ndc10");
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10_format && ndc10_format.length) {
                ndc10.closest("tr").show();

                /*if (user_role == 'field_team') {
                    ndc11.siblings(".input_required_indicator").hide();
                }*/

                switch (ndc10_format) {
                    case "4-4-2":
                        $('input.currency').mask('###0.00', {reverse: true});
                        ndc10.mask("9999-9999-99", {reverse: true});
                        break;
                    case "5-3-2":
                        ndc10.mask("99999-999-99", {reverse: true});
                        break;
                    case "5-4-1":
                        ndc10.mask("99999-9999-9", {reverse: true});
                        break;
                }
            }
            else {
                /*if (user_role == 'field_team') {
                    ndc11.siblings(".input_required_indicator").show();
                }*/
                ndc10.val("").closest("tr").hide();

        //                if (user_role != 'field_team') {
        //                   ndc11.val("").trigger("change");
        //                }
            }

            if (ndc11 && ndc11.val()) {
                ndc11.trigger("change");
            }
        }).trigger("change");

        $("#"+uom+"_ndc10").change(function() {
            var ndc10 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format").val();
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        var str = "0" + ndc10.replace(/\-/g,"");
                        ndc11.val(str);
                        break;
                    case "5-3-2":
                        var str = ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2);
                        ndc11.val(str);
                        break;
                    case "5-4-1":
                        var str = ndc10.substr(0, 5) + ndc10.substr(6, 4)  + "0" + ndc10.substr(11, 1);
                        ndc11.val(str);
                        break;
                }
            }
            else {
        //                if (user_role != 'field_team') {
        //                   ndc11.val("").trigger("change");
        //                }
            }

        }).trigger("change");

        $("#"+uom+"_ndc").change(function() {
            var ndc11 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format");
            var ndc10 = $("#"+uom+"_ndc10");

            if (ndc11.length) {
                /*if (user_role == 'field_team') {
                    if (uom == 'selling_unit') {
                        if (ndc11.length == 11) {
                        ndc10_format.siblings(".input_required_indicator").hide();
                        //ndc10_format.rules('remove','required');
                        }
                        else {
                        ndc10_format.siblings(".input_required_indicator").show();
                        }
                    }
                }*/

                switch (ndc10_format.val()) {
                    case "4-4-2":
                        var str = ndc11.substr(1, 4) + "-" + ndc11.substr(5, 4) + "-" + ndc11.substr(9, 2);
                        ndc10.val(str);
                        break;
                    case "5-3-2":
                        var str = ndc11.substr(0, 5) + "-" + ndc11.substr(6, 3) + "-" + ndc11.substr(9, 2);
                        ndc10.val(str);
                        break;
                    case "5-4-1":
                        var str = ndc11.substr(0, 5) + "-" + ndc11.substr(5, 4)  + "-" + ndc11.substr(10, 1);
                        ndc10.val(str);
                        break;
                }
            }
            else {
                /*if (user_role == 'field_team') {
                    ndc10_format.siblings(".input_required_indicator").show();
                }*/
            }

        }).trigger("change");
    });

    $("#duns").change(function() {
        var value_str = $(this).val();
        $(this).val(value_str.replace(/-/g,""));
    }).trigger("change");

    $("#pr_registration").change(function() {
        var pr_registration = $(this).val();

        if (abcsetup.userRole.class != 'promo_image_reviewer') {
            // pr_registration = Y and there is no pr_registration_doc file uploaded
            if (pr_registration == "Y" && $('input[data-idx="pr_registration_doc"]').val() == '') {
                //$("select[name='rx_item[high_priority_item]']").closest("tr").show();
                $('button#pr_registration_doc').addClass('required btn-danger').show();
                $("pr_reg_coding").val("RRC");

            // pr_registration is not the same value as when the page was loaded
            } else if (pr_registration != abcsetup.item.pr_registration) {
                if (pr_registration == "Y") {
                    //$("select[name='rx_item[high_priority_item]']").closest("tr").show();
                    $('button#pr_registration_doc').addClass('required btn-danger').show();
                    $("pr_reg_coding").val("RRC");
                }
                else if (pr_registration == "in_process") {
                    if (abcsetup.userRole.class == 'vendor' || abcsetup.userRole.class == 'rx_vendor') {
                        abcsetup.alerts.show("Warning: Puerto Rico Distribution: In Process", "By selecting 'In Process', you are indicating that your company has initiated registering this item for sale in Puerto Rico, but have not yet received the registration documentation from the Puerto Rico Department of Health. <br><br><font style='bold' color='#F03200'>YOU WILL NEED TO SUBMIT THE REGISTRATION DOCUMENT AS SOON AS YOU OBTAIN IT.</font>");
                    }
                    //$("select[name='rx_item[high_priority_item]']").closest("tr").show();
                    $('button#pr_registration_doc').removeClass('required btn-danger').show();
                }
                else {
                    //$("select[name='rx_item[high_priority_item]']").closest("tr").hide();
                    //$("#pr_registration_doc").removeClass("btn-required").hide();
                    $('button#pr_registration_doc').removeClass('required btn-danger').hide();
                }
            } else {
                $('button#pr_registration_doc').removeClass('required btn-danger').hide();
            }
        }
    }).trigger("change");

    $(function() {
        if (abcsetup.userRole.class != 'promo_image_reviewer') {
            if ($("#pr_registration").val() != "") {
                if (abcsetup.item.pr_registration != $("#pr_registration").val()) {
                    $("#pr_registration").trigger("change");
                }
            }
            else {
                //$("#pr_registration_doc").removeClass("btn-required").hide();
                $('button#pr_registration_doc').removeClass('required btn-danger');
            }
        }
    });


    /*
    $("#fda_exempt").change(function() {
        var fda_exempt = $(this).val();
        if (fda_exempt == "Y") {
            $("#fda_waiver").addClass("required btn-danger");
        }
        else {
            $("#fda_waiver").removeClass('required btn-danger');
        }
    });

    $(function() {
        if ($("#fda_exempt").length) {
            $("#fda_exempt").trigger("change");
        }
        else {
            $("#fda_waiver").removeClass('required btn-danger');
        }
    });
    */

    var sds_button_iata = false;
    var sds_button_cfr = false;

    $("#product_regulated_cfr").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        $(this).addClass('changed');
        if ($(this).val() == "N") {
            sds_button_cfr = false;
            if (sds_button_iata){
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
                var sds_waiver = $("#sds_waiver").val();
                if (sds_waiver == "N") {
                    $("button#sds_waiver").addClass("required btn-danger").show();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
                else if (sds_waiver == "Y") {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").addClass("required btn-danger").show();
                }
                else {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
        //          $("select[name='front_store_item[sds_waiver]']").addClass('required');
            } else {
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }

            if (!$("#product_regulated_iata").hasClass("disabled")) {
                $("#product_regulated_iata").attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='product_regulated_iata']").remove();
            $("#product_regulated_iata").trigger("change");
        } else {
            // Clear out the IATA flag, force them to select a value
            // Only if they haven't already chosen a new value
            if (!$("#product_regulated_iata").hasClass('changed')){
               $("#product_regulated_iata").val('').trigger('change');
            };

            $("#product_regulated_iata").val("Y").trigger("change");
            $("#product_regulated_iata").attr("disabled",true).parent("td").addClass("readonly");
            $("#product_regulated_iata").after('<input type="hidden" name="product_regulated_iata" value="Y">');
        }
    });

    $("#product_regulated_iata").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        $(this).addClass('changed');
        if ($(this).val() == "N") {
            sds_button_iata = false;
            if (sds_button_cfr){
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
                var sds_waiver = $("#sds_waiver").val();
                if (sds_waiver == "N") {
                    $("button#sds_waiver").addClass("required btn-danger").show();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
                else if (sds_waiver == "Y") {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").addClass("required btn-danger").show();
                }
                else {
                    $("button#sds_waiver").removeClass("required btn-danger").hide();
                    $("button#msds_sheet").removeClass("required btn-danger").hide();
                }
        //          $("select[name='front_store_item[sds_waiver]']").addClass('required');
            } else {
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        } else {
            // Clear out the IATA flag, force them to select a value
            // Only if they haven't already chosen a new value
            if (!$("#product_regulated_cfr").hasClass('changed')){
               $("#product_regulated_cfr").val('').trigger('change');
            };
         }
    });

    $("#un_id_cfr").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        if ($(this).val() != abcsetup.item.un_id_cfr){
            sds_button_cfr = true;
            $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
            $("#sds_waiver").addClass("enforce_required").trigger('change');
            var sds_waiver = $("#sds_waiver").val();
            if (sds_waiver == "N") {
                $("button#sds_waiver").addClass("required btn-danger").show();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
            else if (sds_waiver == "Y") {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").addClass("required btn-danger").show();
            }
            else {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
    //       $("select[name='front_store_item[sds_waiver]']").addClass('required');
        } else {
            sds_button_cfr = false;
            if (!sds_button_iata){
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        }
    });
    $("#un_id_iata").change(function() {
        $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        if ($(this).val() != abcsetup.item.un_id_iata){
            sds_button_iata = true;
            $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
            $("#sds_waiver").addClass("enforce_required").trigger('change');
            var sds_waiver = $("#sds_waiver").val();
            if (sds_waiver == "N") {
                $("button#sds_waiver").addClass("required btn-danger").show();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
            else if (sds_waiver == "Y") {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").addClass("required btn-danger").show();
            }
            else {
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("button#msds_sheet").removeClass("required btn-danger").hide();
            }
    //       $("select[name='front_store_item[sds_waiver]']").addClass('required');
        } else {
            sds_button_iata = false;
            if (!sds_button_cfr){
                $("#sds_waiver").attr('required',false).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        //          $("select[name='front_store_item[sds_waiver]']").removeClass('required');
            }
        }
    });
    // sds_old_val = abcsetup.item.sds_waiver;
    $("#sds_waiver").change(function() {
        var sds_waiver = $(this).val();
        var enforce = false;
        if ($(this).hasClass('enforce_required')) {
            // The SDS sheet / waiver is required by another field change
            enforce = true;
        }
        if (sds_waiver == "N" && (sds_waiver != abcsetup.item.sds_waiver || enforce)) {
            $("button#sds_waiver").addClass("required btn-danger").show();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }
        else if (sds_waiver == "Y" && (sds_waiver != abcsetup.item.sds_waiver || enforce)) {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").addClass("required btn-danger").show();
        }
        else if (sds_waiver == abcsetup.item.sds_waiver) {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }
        else {
            $("button#sds_waiver").removeClass("required btn-danger").hide();
            $("button#msds_sheet").removeClass("required btn-danger").hide();
        }
    }).trigger('change');

    // $("#pr_registration").change(function() {
    //     var pr_registration = $(this).val();
    //     if (pr_registration != abcsetup.item.pr_registration){
    //         if (pr_registration == "Y") {
    //             $("button#pr_registration_doc").addClass("required btn-danger").show();
    //         }
    //         else {
    //             $("button#pr_registration_doc").removeClass("required btn-danger").hide();
    //         }
    //     }
    // });

    $("#trade_agreement").change(function() {
        var trade_agreement = $(this).val();
        if (trade_agreement != abcsetup.item.trade_agreement){
            // if (trade_agreement == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
            // }
            // else {
                // $("button#hda_form").removeClass("required btn-danger").hide();
            // }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
        }
    });

    $("#temp_range").change(function() {
        var temp_range = $(this).val();
        if (temp_range != abcsetup.item.temp_range){
            if (temp_range != "") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
        }
    });

    $("#listed_chemical").change(function() {
        var listed_chemical = $(this).val();
        if (listed_chemical != abcsetup.item.listed_chemical){
            if (listed_chemical == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
                $("#chemical").val('');
                $("#chemical_other").val('');
                $("#chemical_ingredient_amount").val('');
                $("#chemical_ingredient_uom").val('');
                $("#chemical_category").val('');
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#aerosol_class").change(function() {
        var aerosol_class = $(this).val();
        if (aerosol_class != abcsetup.item.aerosol_class){
            if (aerosol_class == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#alcohol").change(function() {
        var alcohol = $(this).val();
        if (alcohol != abcsetup.item.alcohol){
            if (alcohol == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    $("#flammable").change(function() {
        var flammable = $(this).val();
        if (flammable != abcsetup.item.flammable){
            if (flammable == "Y") {
                $("button#hda_form").addClass("required btn-danger").show();
                $("button#flat_product_bar_code_image").addClass("required btn-danger").show();
                // $("button#sds_waiver").addClass("required btn-danger").show();
                $("#sds_waiver").attr('required',true).closest("div.form-group").addClass("required");
                $("#sds_waiver").addClass("enforce_required").trigger('change');
            }
            else {
                $("button#hda_form").removeClass("required btn-danger").hide();
                $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
                $("button#sds_waiver").removeClass("required btn-danger").hide();
            }
        }
        else {
            $("button#hda_form").removeClass("required btn-danger").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").hide();
            $("button#sds_waiver").removeClass("required btn-danger").hide();
        }
    });

    /*$("#sds_waiver").change(function() {
        var sds_waiver = $(this).val();
        if (sds_waiver == "N") {
            $("button[id='sds_waiver']").addClass("btn-required required").show();
            $("#msds_sheet").removeClass("btn-required required").hide();
        }
        else if (sds_waiver == "Y") {
            $("button[id='sds_waiver']").removeClass("btn-required required").hide();
            $("#msds_sheet").addClass("btn-required required").show();
        }
        else {
            $("button[id='sds_waiver']").removeClass("btn-required required").hide();
            $("#msds_sheet").removeClass("btn-required required").hide();
        }

        if (abcsetup.userRole.class == 'asd_buyer' || abcsetup.userRole.class == 'bessie_user' || abcsetup.userRole.class == 'oncology_cm') {
            $("button[id='sds_waiver']").removeClass("required");
            $("#msds_sheet").removeClass("required");
            $("#flat_product_bar_code_image").removeClass("required");
            $("#case_label").removeClass("required");
        }
        else if (abcsetup.userRole.class == 'bluepoint_cm') {
            $("#case_label").removeClass("required");
        }
    });
    $(function() {
        if ($("#sds_waiver").length) {
            $("#sds_waiver").trigger("change");
        }
        else {
            $("button[id='sds_waiver']").removeClass("btn-required required").hide();
            $("#msds_sheet").removeClass("btn-required required").hide();
        }

        if (abcsetup.userRole.class == 'bluepoint_cm') {
            $("#flat_product_bar_code_image").removeClass("required");
        }

        if (abcsetup.userRole.class != 'bluepoint_cm') {
            $("#sap_pricing_letter").removeClass("required").hide();
            $("#ahp_pricing_letter").removeClass("required").hide();
        }
    });*/

    //volume calculation
    $.each(['item','pack','case','pallet'],function() {
        var uom = this;
        $("#"+uom+"_height").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_width").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                var volume = $(this).val() * $("#"+uom+"_width").val() * $("#"+uom+"_depth").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change");
        $("#"+uom+"_width").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_depth").val())) {
                var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_depth").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change");
        $("#"+uom+"_depth").change(function(){
            if ($.isNumeric($(this).val()) && $.isNumeric($("#"+uom+"_height").val()) && $.isNumeric($("#"+uom+"_width").val())) {
                var volume = $(this).val() * $("#"+uom+"_height").val() * $("#"+uom+"_width").val();
                $("#"+uom+"_volume").val(Math.round(volume * 100) / 100);
            }
            else {
                $("#"+uom+"_volume").val("");
            }
        }).trigger("change");
    });

    /*
    * CFR and IATA hazmat
    */
    var hazmat_fields = {
        cfr: [
            "product_regulated",
            "un_id",
            "hazard_class",
            "pack_group",
            "shipping_name_1",
            "label_code",
            "qty_limit_par",
            "qty_limit_cao",
            "vessel_stowage_location",
            "vessel_stowage_other",
        ],
        iata: [
            "product_regulated",
            "un_id",
            "shipping_name",
            "descr",
            "pack_group",
        ],
    };
    var hazmat_types = ['cfr','iata'];
    var hazmat_config = {
        change_field: function(args) {
            // args: hazmat_type, field, data_obj
            console.log("hazmat_config.change_field: args->"+JSON.stringify(args,{},4));
            hazmat_config[args.hazmat_type][args.field+"_select"].obj.empty();
            var list_length = Object.keys(args.data_obj).length;
            if (list_length > 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value","").text("-select-"));
            }
            Object.keys(args.data_obj).forEach(function(key) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value",key).text(key));
            });
            if (list_length == 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
            }
            else {
                if (hazmat_config[args.hazmat_type][args.field+"_select"].obj.find("option[value='"+hazmat_config[args.hazmat_type][args.field+"_select"].val+"']").length) {
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.val(hazmat_config[args.hazmat_type][args.field+"_select"].val);
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
                }
            }
        }
    };

    hazmat_types.forEach(function(hazmat_type) {
        hazmat_config[hazmat_type] = {};
        // field objects
        hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
            hazmat_config[hazmat_type][hazmat_field+"_select"] = {};
            hazmat_config[hazmat_type][hazmat_field+"_select"]["obj"] = $("#"+hazmat_field+"_"+hazmat_type);
            hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = "_undef_";
            if (abcsetup.item != undefined) {
                if (abcsetup.item[hazmat_field+"_"+hazmat_type] != undefined) {
                    hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = abcsetup.item[hazmat_field+"_"+hazmat_type]
                }
            }
        });
    });

    // add event handlers
    var abc_hazmat_obj = {};
    var selected_hazmat_fields = {};
    hazmat_types.forEach(function(hazmat_type) {
        selected_hazmat_fields[hazmat_type] = {};
        console.log('hazmat event handlers');
        if (!hazmat_config[hazmat_type].un_id_select.obj.is(":disabled")) {
            if (hazmat_type == "cfr") {
                console.log('hazmat event handlers: cfr', hazmat_config[hazmat_type].un_id_select.obj);
                // un_id_select -> hazard_class_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    console.log('hazmat event handlers: cfr: un_id change');
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_cfr_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_cfr_search[hazard_class]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "hazard_class",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"]
                                });
                            }
                        }
                    });
                });
                // hazard_class_select -> pack_group_select
                hazmat_config[hazmat_type].hazard_class_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["hazard_class"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group']
                    });
                });
                // pack_group_select -> shipping_name_1_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "shipping_name_1",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"]
                    });
                });
                // shipping_name_1_select -> label_code_select
                hazmat_config[hazmat_type].shipping_name_1_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name_1"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "label_code",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"]
                    });
                });
                // label_code_select -> qty_limit_par_select
                hazmat_config[hazmat_type].label_code_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["label_code"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_par",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"]
                    });
                });
                // qty_limit_par_select -> qty_limit_cao_select
                hazmat_config[hazmat_type].qty_limit_par_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_par"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_cao",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"]
                    });
                });
                // qty_limit_cao_select -> vessel_stowage_location_select
                hazmat_config[hazmat_type].qty_limit_cao_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_cao"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_location",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"]
                    });
                });
                // vessel_stowage_location_select -> vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_location_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_location"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_other",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"]
                    });
                });
                // vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_other_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_other"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    var vessel_stowage_other = selected_hazmat_fields[hazmat_type]["vessel_stowage_other"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"][vessel_stowage_other]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
            else if (hazmat_type == "iata") {
                // un_id_select -> shipping_name_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_iata_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_iata_search[shipping_name]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "shipping_name",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"]
                                });
                            }
                        }
                    });
                });
                // shipping_name_select -> descr_select
                hazmat_config[hazmat_type].shipping_name_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "descr",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr']
                    });
                });
                // descr_select -> pack_group_select
                hazmat_config[hazmat_type].descr_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["descr"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"]
                    });
                });
                // pack_group_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"][pack_group]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
        }
    });
});

/*$("#transmit_uom_inner, #transmit_uom_case").change(function() {
    if ($(this).val() == 'Y') {
        $("#transmit_uom_inner").siblings(".form_error").remove();
        $("#transmit_uom_inner").removeClass("form_error");
        $("#transmit_uom_case").siblings(".form_error").remove();
        $("#transmit_uom_case").removeClass("form_error");
    }
}).trigger("change");

$("input[name='rx_item[replacement_item_sap]']").change(function(){
    var this_parent = $(this).parent();
    this_parent.find(".invalid_sap").remove();
    $("input[name='rx_item[replacement_item_sap_descr]']").val('');
    var patt1 = /[0-9]+/g;
    var sap_num = $(this).val().match(patt1);
    if (sap_num[0].length == 8) {
        $.ajax({
            type: "POST",
            url: BASE_URL+"/abc_item/view.json",
            dataType: 'json',
            data: {search_fields:{sap_num:sap_num[0]}},
            success: function(result) {
                console_log("abc_item/view.json->"+JSON.stringify(result,{},4));
                if (result.item_record.length) {
                    if (result.item_record[0].name) {
                    $("input[name='rx_item[replacement_item_sap_descr]']").val(result.item_record[0].name.trim());
                    }
                }
                else {
                    this_parent.append('<span class="warning small inForm invalid_sap">The SAP number does not exist</span>');
                }
            }
        });
    }
});

$("input[name='rx_item[sap_item_number]']").change(function() {
    if (user_role == 'field_team') {
        if ($(this).val() != '') {
            $("input[name='rx_item[dup_item_reason]']").closest("tr").show();
            $("textarea[name='rx_item[comments]']").siblings(".input_required_indicator").remove();
        }
        else {
            $("input[name='rx_item[sap_item_descr]']").val('');
            $("input[name='rx_item[dup_item_reason]']").closest("tr").hide();
            $("textarea[name='rx_item[comments]']").siblings(".input_required_indicator").remove();
            $("textarea[name='rx_item[comments]']").after('<span class="input_required_indicator">*</span>');
        }
    }

    if ($(this).val() != '') {
        var this_parent = $(this).parent();
        this_parent.find(".invalid_sap").remove();
        $("input[name='rx_item[sap_item_descr]']").val('');
        var patt1 = /[0-9]+/g;
        var sap_num = $(this).val().match(patt1);
        if (sap_num[0].length == 8) {
            $.ajax({
                type: "POST",
                url: BASE_URL+"/abc_item/view.json",
                dataType: 'json',
                data: {search_fields:{sap_num:sap_num[0]}},
                success: function(result) {
                    console_log("abc_item/view.json->"+JSON.stringify(result,{},4));
                    if (result.item_record.length) {
                    if (result.item_record[0].name) {
                        $("input[name='rx_item[sap_item_descr]']").val(result.item_record[0].name.trim());
                    }
                    }
                    else {
                    this_parent.append('<span class="warning small inForm invalid_sap">The SAP number does not exist</span>');
                    }
                }
            });
        }
    }
}).trigger("change");
*/